export default __webpack_public_path__ + "static/media/reddit-alien.2043d824.svg";